var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.amSuchen)?_c('div',{staticClass:"content TOMFragebogen-Baustein-Gruppe",class:_vm.className},[_vm._t("default"),(_vm.buttonsSichtbar)?_vm._t("buttons"):_vm._e()],2):_c('div',{staticClass:"content"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }